// extracted by mini-css-extract-plugin
export default {"rating":"Ly-z","numberOfStars":"My-z","count":"Ny-z","barGraphSpacing":"Oy-z","barGraph":"Py-z"};